<template lang="pug">
MonthlyGrowthCharts(:url="url")
</template>

<script>
export default {
  data() {
    return {
      url: "/invoices/monthly-growth",
    };
  },
};
</script>
